var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card mx-3"},[(!this.userInfo.onlySelf && _vm.$store.state.currentCensusPeriod)?_c('div',[_c('dashboard')],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }